export const getProfilePhotoUrl = (entity) => {
  if (!entity) return '';
  const profilePhoto = entity.profilePhoto || entity.profile_photo;
  const rawUrl = typeof profilePhoto === 'string' ? profilePhoto : (
    profilePhoto?.publicUrl ||
    profilePhoto?.public_url ||
    entity.photo ||
    entity.avatar ||
    entity.image ||
    ''
  );
  if (rawUrl?.startsWith('/api')) {
    return `${process.env.REACT_APP_BACKEND_URL || ''}${rawUrl}`;
  }
  return rawUrl || '';
};

export const getPersonName = (entity, fallback = 'Magnolia user') => {
  if (!entity) return fallback;
  return (
    entity.name ||
    [entity.firstName || entity.first_name, entity.lastName || entity.last_name].filter(Boolean).join(' ') ||
    fallback
  );
};

export const getInitials = (entity, fallback = 'U') => {
  const name = getPersonName(entity, '').trim();
  if (name) {
    return name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
  }
  const first = entity?.firstName || entity?.first_name || '';
  const last = entity?.lastName || entity?.last_name || '';
  return `${first[0] || ''}${last[0] || ''}`.toUpperCase() || fallback;
};
